"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderCellSortable = TableHeaderCellSortable;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../constants/icons");

var _excluded = ["children", "sortObject", "columnName", "onSort"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sortOrders = {
  asc: 'asc',
  desc: 'desc'
};

function isValidSortObject(sortObject) {
  return !!sortObject && !!sortObject.sortOrder && !!sortObject.columnName;
}

function isCurrentColumnSorted(sortObject, columnName) {
  return sortObject.columnName === columnName;
}

function isValidSortOrder(sortObject) {
  return !!sortOrders[sortObject.sortOrder];
} // eslint-disable-next-line complexity


function sort(_ref) {
  var _ref$sortObject = _ref.sortObject,
      sortObject = _ref$sortObject === void 0 ? {} : _ref$sortObject,
      _ref$columnName = _ref.columnName,
      columnName = _ref$columnName === void 0 ? '' : _ref$columnName,
      onSort = _ref.onSort;

  if (!sortObject || sortObject.columnName !== columnName) {
    onSort({
      columnName: columnName,
      sortOrder: sortOrders.asc
    });
    return;
  }

  if (sortObject.sortOrder === sortOrders.asc) {
    onSort({
      columnName: columnName,
      sortOrder: sortOrders.desc
    });
    return;
  }

  onSort(null);
}

function columnIsSorted(sortObject, columnName) {
  return isValidSortObject(sortObject) && isCurrentColumnSorted(sortObject, columnName) && isValidSortOrder(sortObject);
}

function renderSortIndicator(sortObject, columnName) {
  var iconBaseClass = 'table-header-cell__sort-icon';

  if (!columnIsSorted(sortObject, columnName)) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(iconBaseClass, " ").concat(iconBaseClass, "--not-sorted ").concat(_icons.icons.sort)
    });
  }

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(iconBaseClass, " ").concat(_icons.icons[sortObject.sortOrder])
  });
}

function TableHeaderCellSortable(props) {
  var children = props.children,
      sortObject = props.sortObject,
      columnName = props.columnName,
      onSort = props.onSort,
      remainingProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement("th", _extends({}, remainingProps, {
    className: "table-header-cell table-header-cell--sortable",
    onClick: function onClick() {
      return sort(props);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "table-header-cell__sort-text"
  }, children), renderSortIndicator(sortObject, columnName));
}

TableHeaderCellSortable.propTypes = {
  columnName: _propTypes["default"].string.isRequired,
  onSort: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node,
  sortObject: _propTypes["default"].shape({
    columnName: _propTypes["default"].string,
    sortOrder: _propTypes["default"].string
  })
};
TableHeaderCellSortable.defaultProps = {
  children: null,
  sortObject: null
};